import React from 'react';
import {
    List,
    Typography,
} from 'antd';
import moment from 'moment';

import MoneyTitle from '../customer/MoneyTitle';
import { dayActivityTotals, tapsWord, itemsWord } from '../../utils/dayActivityTotals';

const { Text } = Typography;

function getActivitiesByDay(activities, maxDays = 0) {
  const activitiesByDay = {};
  const daysOfActivity = [];
  activities && activities.map((activity, i) => {
      const activityAt = activity.activityAt;
      const dayOfActivity = activityAt && moment(activityAt.toMillis()).format("YYYYMMDD").toString();
      if (activitiesByDay[dayOfActivity] == null) {
          activitiesByDay[dayOfActivity] = [];
          daysOfActivity.push(dayOfActivity);
      }
      return activitiesByDay[dayOfActivity].push({ ...activity, updatedAt: activityAt });
  });

  const numOfDays = daysOfActivity.length;
  const spliceCount = (maxDays > 0 && numOfDays > maxDays) ? maxDays : numOfDays;

  return {
      daysOfActivity: daysOfActivity.sort((a, b) => b - a).splice(0, spliceCount),
      activitiesByDay
  };
}

/**
 * The day's header: "October 16, 2026 (2)", or with `dayTotals` the day's net
 * tip total — "October 16, 2026 (€56.96 in 2 tips)" ("2 donations" for a
 * giving team, "2 payments" for a paying one, "2 taps" for a day that mixes
 * them). Only taps credited in
 * are totalled; a day that also lists payouts or refunds says
 * "(€56.96 in 2 tips · 3 items)", and a day with none says "(3 items)".
 */
export const DayHeader = ({ dayLabel, activities, dayTotals }) => {
  if (!dayTotals) {
    return <Text strong>{`${dayLabel} (${activities.length})`}</Text>;
  }

  const { tips, tipCount, itemCount } = dayActivityTotals(activities);
  const parts = tips.map((tip) => (
    <span key={`dh-${tip.currency}`}>
      <MoneyTitle amount={tip.amount} currency={tip.currency} digits={2} /> in {tapsWord(tip.count, tip.kinds)}
    </span>
  ));
  if (tipCount !== itemCount) {
    parts.push(<span key='dh-items'>{itemsWord(itemCount)}</span>);
  }

  return (
    <Text strong>
      {dayLabel} (
      {parts.map((part, i) => (
        <React.Fragment key={part.key}>{i > 0 && ' · '}{part}</React.Fragment>
      ))}
      )
    </Text>
  );
};

export const DailyRecentActivityList = ({ listItemComponent, recentActivities, isAdmin, locStrings, maxDays, dayTotals, ...rest }) => {
  const { daysOfActivity, activitiesByDay } = getActivitiesByDay(recentActivities, (maxDays && maxDays > 0) ? maxDays : 32);

  return (
      <>
          { 
              <List
                  style={{ width: '100%' }}
                  loading={!recentActivities}
                  dataSource={daysOfActivity || []}
                  itemLayout={'vertical'}
                  renderItem={item => (
                      <ActivityDailyList
                          activities={activitiesByDay[item] || {}}
                          locStrings={locStrings}
                          isAdmin={isAdmin}
                          listItemComponent={listItemComponent}
                          dayTotals={dayTotals}
                      />
                  )}
              />
          }
      </>
  );

};

const ActivityDailyList = ({ listItemComponent: ActivityListItem, activities, isAdmin, locStrings, dayTotals, ...rest }) => {
  const firstActivity = activities[0];
  const dayOfActivity = (firstActivity && firstActivity.activityAt && moment(firstActivity.activityAt.toMillis()).format('LL')) || 'No Date';

  return (
      <List.Item  >
          <List
              style={{ width: '100%' }}
              header={<DayHeader dayLabel={dayOfActivity} activities={activities} dayTotals={dayTotals} />}
              dataSource={activities}
              itemLayout='horizontal'
              size='default'
              split={false}
              renderItem={item => (
                  <>
                      <ActivityListItem
                          item={item}
                          {...item}
                          locStrings={locStrings}
                          isAdmin={isAdmin}
                      />
                  </>
              )}
          />
      </List.Item>
  );
};
